export const webPixelID = 462717499812265;

export const conversionApiVersion = 'v26.0';

export const defaultPayload = {
  event_name: 'Subscribe',
  event_time: +new Date(),
  event_id: 'Subscribe',
  action_source: 'website',
  user_data: {},
  custom_data: {
    currency: 'USD',
    predicted_ltv: '800',
    value: '49.99',
  },
};

export const subscribePayload = {
  ...defaultPayload,
};

export const checkoutPayload = {
  ...defaultPayload,
  event_name: 'InitiateCheckout',
  custom_data: {
    content_category: 'Checkout',
    content_ids: null,
    contents: 'StartingPayment',
    currency: 'USD',
    num_items: 1,
    value: 49.99,
  },
};

export const startTrialPayload = {
  ...defaultPayload,
  event_name: 'StartTrial',
};

export const viewContentPayload = {
  ...defaultPayload,
  event_name: 'ViewContent',
  custom_data: {
    content_ids: null,
    content_category: 'page',
    content_name: 'PageView',
    content_type: 'Page',
  },
};

export const schedulePayload = {
  ...defaultPayload,
  event_name: 'Schedule',
  custom_data: {
    event_date: null,
  },
};
